<template>
  <m-pay-layout>

      <v-layout justify-center align-top class="mx-2">
        <v-flex grow>

          <m-pay-generic-paging-table
            :headers="headers"
            :queryFunctionName="queries.userMerchantEmployees.name"
            :cellClasses="cellClasses"
          >

            <template slot-scope={item} slot="details">
              <router-link :to="{ name: 'user', params: { userId: item.id } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">zoom_in</v-icon>
                      </span>
                  <span>User Details</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={item} slot="merchant">
              <router-link
                :to="{ name: 'merchant', params: { merchantId: item.merchantId } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">store</v-icon>
                      </span>
                  <span>Merchant</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={item} slot="customer">
              <router-link
                :to="{ name: 'customer', params: { customerId: item.customerId } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">person</v-icon>
                      </span>
                  <span>Customer</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={value} slot="externalId">
              <m-pay-copy-button :value="value"></m-pay-copy-button>
            </template>
            <template slot-scope={value} slot="reasonCode">
              <m-pay-status :value-classes="purchaseReasonCodeClasses" :value="value"/>
            </template>
            <template slot-scope={value} slot="lastCallbackStatus">
              <m-pay-status :value-classes="purchaseCallbackStatusClasses" :value="value"/>
            </template>
          </m-pay-generic-paging-table>

          <v-btn class="ml-0"
               color="secondary"
               @click.native="addEmployee">
            Create
            <v-icon right dark>add</v-icon>
          </v-btn>

        </v-flex>
      </v-layout>

    </m-pay-layout>
</template>

<script>
import MPayGenericPagingTable from '../MPayGenericPagingTable';
import roles from '../../utils/user-roles';

export default {
  name: 'MPayMerchantEmployeesPage',
  components: { MPayGenericPagingTable },
  data: () => ({
    merchantEmployees: [],
    totalMerchantEmployees: 0,
    merchant: {},
    headers: [
      { text: '', value: 'details', sortable: false, filterable: false },
      { text: 'Name', value: 'firstName' },
      { text: 'Surname', value: 'lastName' },
      { text: 'Position', value: 'position' },
      { text: 'Status', value: 'status' },
      { text: 'Role', value: 'role', role: roles.UPDATE_MERCHANT_EMPLOYEE },
      { text: 'Description', value: 'description' },
    ],
    cellClasses: {
      details: 'pl-3 pr-1',
      transactions: 'pl-0 pr-1',
      merchant: 'pl-0 pr-1',
      customer: 'pl-0 pr-1',
    },
    loading: false,
  }),
  methods: {
    addEmployee() {
      this.$router.push({ name: 'add-employee' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantEmployeesPage.vue